<template>
  <div>
    <draggable v-model="data" handle=".handle">
    <div v-for="(question, i) in data" class="hit-form-group">
      <div class="hit-input-group">
        <div class="hit-input-group-addon handle">
          <i class="hit-glyphicon hit-glyphicon-menu-hamburger"></i>
        </div>
        <input type="text" v-bind:value="question[0]" v-on:change="function(e){ set_change_question(e.target.value, edit.row, i); }" class="hit-form-control" v-bind:placeholder="$t('message.add', {name: $tc('message.question',1)})">
        <div class="hit-input-group-btn">
          <div class="hit-btn hit-btn-danger" v-on:click="remove_question(edit.row, i)">
            <i class="hit-glyphicon hit-glyphicon-minus"></i>
          </div>
          <div class="hit-btn hit-btn-success" v-on:click="add_question(edit.row, i)">
            <i class="hit-glyphicon hit-glyphicon-plus"></i>
          </div>
        </div>
      </div>
    </div>
    </draggable>

    <transition name="fade">
      <div v-bind:key="saved" v-show="saved" class="hit-text-success"><hit_icon :id='"ok"' /> {{ $t("message.successfullSaved") }}</div>
    </transition>
  </div>
</template>

<script>

import draggable from 'vuedraggable'

export default{

  props: { edit: Object},
  components: {draggable},

  data () {
    return {
      data: this.$store.getters.boards[this.edit.row].data,
      saved: false
    }
  },

  methods: {

    set_saved: function () {
      this.saved = true

      setTimeout(function () {
        this.saved = false
      }.bind(this), 2000)
    },
    get_empty_questions: function (index) {
      var r = 0

      for (var i = 0; i < this.$store.getters.boards[index].data.length; i++) {
        if (this.$store.getters.boards[index].data[i][0] === '') { r++ }
      }

      return r
    },
    remove_question: function (index, i) {
      if (this.$store.getters.boards[index].data.length == 1) { return false }

      this.$store.getters.boards[index].data.splice((i), 1)

      this.$store.dispatch('set_change_board', {index: index, data: {data: this.$store.getters.boards[index].data} })

      this.set_saved()
    },
    add_question: function (index, i) {
      this.$store.getters.boards[index].data.splice((i + 1), 0, [''])

      this.$store.dispatch('set_change_board', {index: index, data: {data: this.$store.getters.boards[index].data} })

      this.set_saved()
    },

    set_change_question: function (text, index, question) {
      this.$store.getters.boards[index].data[question][0] = text

      this.$store.dispatch('set_change_board', {index: index, data: {data: this.$store.getters.boards[index].data} })

      this.warning_sign_key = new Date().getTime()

      this.set_saved()
    },
    set_edit_questions: function (index) {
      if (index === this.edit_question) {
        this.edit_question = false
        return false
      }

      this.edit_question = index
      this.edit_pass = false
    }

  }
}

</script>
